import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-patient-book-card',
  templateUrl: './patient-book-card.component.html',
  styleUrls: ['./patient-book-card.component.css']
})
export class PatientBookCardComponent implements OnInit {

  constructor() { }

  @Input() doc;
  @Output() clickAction = new EventEmitter();

  ngOnInit() {
  }

  doctorSelection(data) {
    this.clickAction.emit(data);

  }

}
